var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 19,
    viewBox: "0 0 31 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41406 18L0.753906 1.08984H4.66797L8.53516 14.3789H8.60547L12.4609 1.08984H16.3867L10.7266 18H6.41406ZM23.9922 18.293C19.9727 18.293 17.3828 16.4531 17.1836 13.3359L17.1719 13.1484H20.5117L20.5352 13.2773C20.7578 14.5898 22.1523 15.4102 24.0859 15.4102C26.043 15.4102 27.2734 14.5547 27.2734 13.2656V13.2539C27.2734 12.1055 26.4414 11.5312 24.3438 11.0977L22.5625 10.7461C19.2227 10.0781 17.5352 8.48438 17.5352 5.94141V5.92969C17.5352 2.83594 20.2305 0.796875 23.9805 0.796875C27.8945 0.796875 30.2969 2.75391 30.4609 5.71875L30.4727 5.94141H27.1328L27.1211 5.80078C26.9453 4.47656 25.7266 3.66797 23.9805 3.66797C22.1641 3.67969 21.0742 4.51172 21.0742 5.71875V5.73047C21.0742 6.79688 21.9414 7.41797 23.8867 7.80469L25.6797 8.16797C29.2188 8.87109 30.8125 10.3125 30.8125 12.9727V12.9844C30.8125 16.2305 28.2578 18.293 23.9922 18.293Z",
    fill: "url(#paint0_linear_18532_123347)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18532_123347",
    x1: -2.38419e-7,
    y1: 9.5,
    x2: 32,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005DB4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVs);
export default __webpack_public_path__ + "static/media/vs.6a1721d81618bc41c21750ea3e2454ba.svg";
export { ForwardRef as ReactComponent };